import React, { forwardRef } from "react";
import "./TextEditor.scss";
import { ReactSVG } from "react-svg";

import boldIcon from '../../Assets/icons/bold-square.svg'
import italicIcon from '../../Assets/icons/italic-square.svg'
import underlineIcon from '../../Assets/icons/underline-square.svg'
import strikethroughIcon from '../../Assets/icons/strikethrough-square.svg'
import unsortedListIcon from '../../Assets/icons/dotpoints.svg'
import numberedListIcon from '../../Assets/icons/numberpoint.svg'

enum TextFormat {
    Bold = 'bold',
    Italic = 'italic',
    Underline = 'underline',
    StrikeThrough = 'strikeThrough',
    UnorderedList = 'insertUnorderedList',
    OrderedList = 'insertOrderedList'
}

interface ITextEditorProps extends React.ButtonHTMLAttributes<HTMLDivElement> {}

const TextEditor = forwardRef<HTMLDivElement, ITextEditorProps>((props, ref) => {
    const toggleTextFormat = (format: TextFormat): void => {
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) return;
        document.execCommand(format, false);
      };
      
      const formatBold = (): void => {
        toggleTextFormat(TextFormat.Bold);
      };

    const formatItalic = (): void => {
        toggleTextFormat(TextFormat.Italic);
    };

    const formatUnderline = (): void => {
        toggleTextFormat(TextFormat.Underline);
    };
      
      const formatStrikethrough = (): void => {
        toggleTextFormat(TextFormat.StrikeThrough);
      };

    const formatUnorderedList = () => {
        toggleTextFormat(TextFormat.UnorderedList);
    };

    const formatOrderedList = () => {
        toggleTextFormat(TextFormat.OrderedList);
    };

    return (
        <div className={`text-editor-container`}>
            <div className="te-actions">
                {/* <button onClick={formatAsH1}><ReactSVG src={headingIcon}/></button> */}
                {/* <button onClick={formatAsH2}>H2</button> */}
                {/* <button onClick={formatAsH3}>H3</button> */}
                <button onClick={formatBold}><ReactSVG src={boldIcon}/></button>
                <button onClick={formatItalic}><ReactSVG src={italicIcon}/></button>
                <button onClick={formatUnderline}><ReactSVG src={underlineIcon}/></button>
                <button onClick={formatStrikethrough}><ReactSVG src={strikethroughIcon}/></button>
                <button onClick={formatUnorderedList}><ReactSVG src={unsortedListIcon}/></button>
                <button onClick={formatOrderedList}><ReactSVG src={numberedListIcon}/></button>
                {/* <button onClick={formatTable}>Tabel</button> */}
            </div>
        </div>
    );
});

export default TextEditor;
